/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Session_UserId = ls.getSessionValueByKey('UserId');
const meetingRef = con.eventDB.collection(cn).doc('MeetingList').collection('Meetings')
const meetingSettingsRef = con.eventDB.collection(cn).doc('MeetingList').collection('Settings').doc('Config');
const meetingLocationRef = con.eventDB.collection(cn).doc('MeetingList').collection('LocationList');
var attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
const storageRef = con.storageRef
var DeleteCollectionApi = con.DeleteCollectionApi
var MeetingConfigAPI = con.MeetingConfigAPI
var MeetingListAPI = con.MeetingListAPI
var FirebaseAuthApi = con.FirebaseAuthApi;
var MeetingAcceptAPI = con.MeetingAcceptAPI;
var MeetingRejectAPI = con.MeetingRejectAPI;
var MeetingCancelAPI = con.MeetingCancelAPI;
var MeetingDeleteAPI = con.MeetingDeleteAPI;
var MeetingDeleteAPI2 = con.MeetingDeleteAPI2;
var O2OZoomAdapter = con.O2OZoomAdapter;
var MeetingStat = con.MeetingStat;

export default {
    fetchMeetingsOLD({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            meetingRef.orderBy("StartDateTime", "desc").get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_MEETINGS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchMeetings(context) {
        let promise = new Promise((resolve, reject) => {
            const markers = []
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    }
                }

                axios.put(MeetingListAPI, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    let Accepted = response.data.result.Accepted
                    let Canceled = response.data.result.Canceled
                    //let FYI = response.data.result.FYI
                    let Pending = response.data.result.Pending
                    let Rejected = response.data.result.Rejected
                    Accepted.forEach(row => {
                        markers.push(row)
                    })
                    Canceled.forEach(row => {
                        markers.push(row)
                    })
                    /*FYI.forEach(row => {
                        markers.push(row)
                    })*/
                    Pending.forEach(row => {
                        markers.push(row)
                    })
                    Rejected.forEach(row => {
                        markers.push(row)
                    })
                    context.commit('SET_MEETINGS', markers)
                    context.commit('SET_MEETING_TYPES', {
                        Accepted: Accepted,
                        Attended: response.data.headers.Attended,
                        Canceled: Canceled,
                        Pending: Pending,
                        Rejected: Rejected
                    })
                    resolve(markers)
                    
                }).catch(err=>{console.log(err); resolve([])})
            })
        })
        return promise;
    },
    fetchMeeting(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        MappedAttendees: [],
                        Host: [],
                        Occupied: 0,
                        CreatedByName: '',
                        CreatedDate: '',
                        SpectatorEnabled: true,
                        Capacity: 10,
                        CreatedByID: 0,
                        IsPublished: true,
                        //IsTableCreator:'',
                        LastModifiedDate: '',
                        TableId: '',
                        TableName: '',
                        Topic: { TopicId: 'RTT1591264542309', TopicName: 'General' },
                        //TopicId:'',
                        //TopicName:'',

                        TableType: 'Open',
                        Spectate: 'On',
                        PreAssignedType: 'Public',
                        MapTo: { IsMapped: false, Type: "Exhibitor", Entity: {} }

                    }
                })
            } else {
                let docObj = new Object
                meetingRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    docObj.TableType = (doc.data().PreAssigned ? 'Pre_assigned' : 'Open')
                    docObj.Spectate = doc.data().SpectatorEnabled
                    if (docObj.MapTo == undefined) {
                        docObj.MapTo = { IsMapped: false, Type: "Exhibitor", Entity: {} }
                    } else {
                        if (docObj.MapTo.IsMapped == undefined) {
                            docObj.MapTo = { IsMapped: false, Type: "Exhibitor", Entity: {} }
                        }
                        docObj.MapToOld = docObj.MapTo;
                    }
                    //console.log(docObj)                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    fetchLocations({ commit }){
        return new Promise((resolve, reject) => {
            const markers = []
            meetingLocationRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    addLocation(context, field) {
        //console.log(atob(field.id));
        //console.log(field); 

        return new Promise((resolve, reject) => {
            let AutoID = "ML" + new Date().getTime();
            let docObj = {
                CreatedBy: '',
                CreatedDate: new Date(),
                LocationId: AutoID,
                LocationName: field.LocationName,
                LastModifiedDate: new Date()
            };

            //let nameMatched = false
            meetingLocationRef.get().then(querySnapshot => {
                if (querySnapshot.size) {
                    let namenotMatched = true
                    querySnapshot.docs.forEach(doc => {
                        if (doc.data().LocationName.toLowerCase() == field.LocationName.toLowerCase()) {
                            namenotMatched = false
                        }
                    });

                    if (namenotMatched) {
                        meetingLocationRef.doc(`${AutoID}`).set(docObj).then(function() {
                            resolve({ status: 200, message: 'Location Added.' });
                        }).catch(function(error) {
                            //console.log(error)
                            reject(error);
                        });
                    } else {
                        resolve({ status: 200, message: 'Location Already Exist!.' });
                    }

                } else {
                    //console.log("not exist doc")
                    meetingLocationRef.doc(`${AutoID}`).set(docObj).then(function() {
                        resolve({ status: 200, message: 'Location Added.' });
                    }).catch(function(error) {
                        //console.log(error)
                        reject(error);
                    })
                }
            }).catch(function(error) {
                reject(error);
                //console.log(error)
            });
        })
    },
    updateMeeting(context, field) {
        //console.log(field)
        return new Promise((resolve, reject) => {
            meetingRef.doc(`${field.id}`).update({
                    TableName: field.data.TableName,
                    Capacity: field.data.Capacity,
                    Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                    PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                    SpectatorEnabled: field.data.Spectate,
                    MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                    CreatedByName: '',
                    CreatedByID: '',
                    IsPublished: field.data.IsPublished,
                    Topic: field.data.Topic,
                    MapTo: field.data.MapTo,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    if (field.data.Host.AttendeeId) {
                        let ParticipanceRef = meetingRef.doc(`${field.id}`).collection('Participances').doc(`${field.data.Host.AttendeeId}`)
                        ParticipanceRef.get().then(function(doc) {
                            if (!doc.exists) {
                                ParticipanceRef.set({
                                    AttendeeId: field.data.Host.AttendeeId,
                                    Name: field.data.Host.Name,
                                    FirstName: field.data.Host.FirstName,
                                    LastName: field.data.Host.LastName,
                                    ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                    Designation: field.data.Host.Designation,
                                    IsActive: false,
                                    JoinTime: new Date(),
                                    LeaveTime: null,
                                    TableId: field.id,
                                    UserAgent: ''
                                })
                            } else {
                                ParticipanceRef.update({
                                    Name: field.data.Host.Name,
                                    FirstName: field.data.Host.FirstName,
                                    LastName: field.data.Host.LastName,
                                    ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                    Designation: field.data.Host.Designation
                                        //IsActive: true,
                                        //JoinTime: new Date(),
                                        //LeaveTime: null,
                                        //TableId: AutoID,
                                        //UserAgent: ''
                                })
                            }
                        })
                    }
                    debugger
                    var needToRemoveOld = false;
                    if (field.data.MapToOld != undefined) {
                        if (field.data.MapToOld.Entity != undefined) {
                            if (field.data.MapToOld.Entity.Id != undefined) {
                                if (field.data.MapTo.Entity.Id != undefined) {
                                    if (field.data.MapTo.Entity.Id != field.data.MapToOld.Entity.Id) {
                                        needToRemoveOld = true;
                                        exhibitorRef.doc(`${field.data.MapToOld.Entity.Id}`).get().then(function(exDoc) {
                                            if (exDoc.exists) {
                                                exhibitorRef.doc(`${field.data.MapToOld.Entity.Id}`).update({
                                                        //MappedMeetings: firebase.firestore.FieldValue.arrayRemove({ TableId: field.id, TableName: field.data.TableName }),
                                                        MappedMeetings: {},
                                                        LastModifiedDate: new Date()
                                                    })
                                                    .then(function(doc) {
                                                        resolve({ status: 200, message: 'Data Updated.' })
                                                    }).catch(function(error) {
                                                        //console.log('Error getting update attendee:', error)
                                                        reject(error)
                                                    })
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    }
                    exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).get().then(function(exDoc) {
                        if (exDoc.exists) {
                            //if (exDoc.data().MappedMeetings) {
                            //    exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                            //            //MappedMeetings: firebase.firestore.FieldValue.arrayUnion({ TableId: field.id, TableName: field.data.TableName }),
                            //            MappedMeetings: [{ TableId: field.id, TableName: field.data.TableName }],
                            //            LastModifiedDate: new Date()
                            //        })
                            //        .then(function(doc) {
                            //            resolve({ status: 200, message: 'Data Updated.' })
                            //        }).catch(function(error) {
                            //            //console.log('Error getting update attendee:', error)
                            //            reject(error)
                            //        })
                            //} else {
                            exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                                    //MappedMeetings: firebase.firestore.FieldValue.arrayUnion([{ TableId: field.id, TableName: field.data.TableName }]),
                                    MappedMeetings: [{ TableId: field.id, TableName: field.data.TableName }],
                                    LastModifiedDate: new Date()
                                })
                                .then(function(doc) {
                                    resolve({ status: 200, message: 'Data Updated.' });
                                }).catch(function(error) {
                                    //console.log('Error getting update attendee:', error)
                                    reject(error);
                                });
                            //}
                        } else {
                            resolve({ status: 200, message: 'Data Updated.' });
                        }
                    });

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                });
        })
    },
    updateStatus(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            meetingRef.doc(`${field.id}`).update({
                    IsPublished: field.IsPublished,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                });
        });
    },

    addMeeting(context, field) {
        debugger
        //console.log(atob(field.id));
        //console.log(field); 
        //context.dispatch('getAutoId')
        return new Promise((resolve, reject) => {
            //let AutoID = "RT" + new Date().getTime();
            //let AutoID = context.dispatch('getAutoId');
            let docObj = {
                TableId: null,
                //AutoID: AutoID,
                TableName: field.data.TableName,
                Capacity: field.data.Capacity,
                Occupied: 0,
                Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                SpectatorEnabled: field.data.Spectate,
                MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                CreatedByName: field.data.CreatedByName,
                CreatedByID: field.data.CreatedByID,
                CreatedDate: new Date(),
                IsPublished: field.data.IsPublished,
                Topic: field.data.Topic,
                MapTo: field.data.MapTo,
                LastModifiedDate: new Date()
            };
            context.dispatch('getAutoId').then(AutoID => {
                docObj.TableId = AutoID;
                meetingRef.doc(`${AutoID}`).set(docObj).then(function() {
                    if (field.data.Host.AttendeeId) {
                        meetingRef.doc(`${AutoID}`).collection('Participances').doc(`${field.data.Host.AttendeeId}`).set({
                            AttendeeId: field.data.Host.AttendeeId,
                            Name: field.data.Host.Name,
                            FirstName: field.data.Host.FirstName,
                            LastName: field.data.Host.LastName,
                            ProfilePictureURL: field.data.Host.ProfilePictureURL,
                            Designation: field.data.Host.Designation,
                            IsActive: false,
                            JoinTime: new Date(),
                            LeaveTime: null,
                            TableId: AutoID,
                            UserAgent: ''
                        });
                    }
                    debugger
                    exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).get().then(function(exDoc) {
                        if (exDoc.exists) {
                            if (exDoc.data().MappedMeetings) {
                                if (exDoc.data().MappedMeetings.length > 0) {
                                    var mappedExhibitorTRId = exDoc.data().MappedMeetings[0].TableId;
                                    meetingRef.doc(`${mappedExhibitorTRId}`).update({
                                            //MappedMeetings: firebase.firestore.FieldValue.arrayUnion({ TableId: AutoID, TableName: field.data.TableName }),
                                            MapTo: {},
                                            LastModifiedDate: new Date()
                                        })
                                        .then(function(doc) {
                                            debugger
                                            resolve({ status: 200, message: 'Data Updated.' });
                                        }).catch(function(error) {
                                            debugger
                                            //console.log('Error getting update mapping:', error)
                                            reject(error);
                                        });
                                }
                            }
                            //if (exDoc.data().MappedMeetings) {
                            //    exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                            //            //MappedMeetings: firebase.firestore.FieldValue.arrayUnion({ TableId: AutoID, TableName: field.data.TableName }),
                            //            MappedMeetings: [{ TableId: AutoID, TableName: field.data.TableName }],
                            //            LastModifiedDate: new Date()
                            //        })
                            //        .then(function(doc) {
                            //            debugger
                            //            resolve({ status: 200, message: 'Data Updated.' })
                            //        }).catch(function(error) {
                            //            debugger
                            //            //console.log('Error getting update mapping:', error)
                            //            reject(error)
                            //        })
                            //} else {
                            exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                                    MappedMeetings: [{ TableId: AutoID, TableName: field.data.TableName }],
                                    LastModifiedDate: new Date()
                                })
                                .then(function(doc) {
                                    resolve({ status: 200, message: 'Data Updated.' });
                                }).catch(function(error) {
                                    //console.log('Error getting update mapping:', error)
                                    reject(error);
                                });
                            //}
                        }
                    });

                    resolve({ status: 200, message: 'Data Added.', Id: field.data.TableId });
                }).catch(function(error) {
                    reject(error)
                });
            })
        });
    },
    async updateExhibitorMappedMeetings(context, field) {
        return new Promise((resolve, reject) => {
            exhibitorRef.doc(`${field.id}`).update({
                    MappedMeetings1: field.data.MappedMeetings,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                });
        })
    },
    fetchMeetingTopicDropdown({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            meetingtopicRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ TopicId: doc.data().TopicId, TopicName: doc.data().TopicName })
                });
                commit('SET_ROUNDTABLETOPICS', markers);
                resolve(markers);
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error);
            })

        })
    },
    addMeetingTopic(context, field) {
        //console.log(atob(field.id));
        //console.log(field); 

        return new Promise((resolve, reject) => {
            let AutoID = "RTT" + new Date().getTime();
            let docObj = {
                CreatedBy: '',
                CreatedDate: new Date(),
                TopicId: AutoID,
                TopicName: field.TopicName,
                IsPrivate: true,
                LastModifiedDate: new Date()
            };

            //let nameMatched = false
            meetingtopicRef.get().then(querySnapshot => {
                if (querySnapshot.size) {
                    let namenotMatched = true
                    querySnapshot.docs.forEach(doc => {
                        if (doc.data().TopicName.toLowerCase() == field.TopicName.toLowerCase()) {
                            namenotMatched = false
                        }
                    });

                    if (namenotMatched) {
                        meetingtopicRef.doc(`${AutoID}`).set(docObj).then(function() {
                            resolve({ status: 200, message: 'Topic Added.' });
                        }).catch(function(error) {
                            //console.log(error)
                            reject(error);
                        });
                    } else {
                        resolve({ status: 200, message: 'Topic Already Exist!.' });
                    }

                } else {
                    //console.log("not exist doc")
                    meetingtopicRef.doc(`${AutoID}`).set(docObj).then(function() {
                        resolve({ status: 200, message: 'Topic Added.' });
                    }).catch(function(error) {
                        //console.log(error)
                        reject(error);
                    })
                }
            }).catch(function(error) {
                reject(error);
                //console.log(error)
            });
        })
    },
    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },
    getSettingsOLD(context) {
        let promise = new Promise((resolve, reject) => {
            meetingSettingsRef.get().then(function(doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve(null)
                }

            })
        })
        return promise;
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                }

                axios.post(MeetingConfigAPI, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    resolve(response.data.data)
                }).catch(err=>{console.log(err)})
            })
        })
        return promise;
    },
    getMeetingStat(context) {
        let promise = new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                }

                axios.post(MeetingStat, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    if(response.data.status == 0)
                        resolve(response.data.results)
                    else
                        resolve([]);
                }).catch(err=>{reject(err)})
            })
        })
        return promise;
    },
    saveSettingsOLD(context, field) {
        let promise = new Promise((resolve, reject) => {
            meetingSettingsRef.get().then(function(doc) {
                if (doc.exists) {
                    meetingSettingsRef.update(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                } else {
                    meetingSettingsRef.set(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                if(field.IsDefaultSettings)
                {
                    field.settingsData.DefaultSettingsLoaded = true;
                    //context.dispatch('loadDefaultSettings');
                }
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                    "data": field.settingsData
                }

                axios.put(MeetingConfigAPI, requestData, { headers: headers }).then((response) => {
                    console.log(response)                    
                    resolve({ status: 200, message: 'Data Updated' })
                }).catch(err=>{console.log(err)})
            })
        })
        return promise;
    },
    getFirebaseAccessToken(context) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
        })
    },
    changeStatusBK(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    meetingRef.doc(`${data.TableId}`)
                        .update({ IsPublished: field.Status })
                        .then(function() {
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    changeStatusOLD(context, field) {
        return new Promise((resolve, reject) => {
            meetingRef.doc(`${field.id}`).update({
                    Status: field.status,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    context.dispatch('fetchMeetings');
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                });
        });
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                    "data": {
                        "MeetingId": `${field.id}`
                    }
                }
                let remoreAPI = "";
                if(field.status == "Accepted")
                    remoreAPI = MeetingAcceptAPI;
                else if(field.status == "Cancelled")
                    remoreAPI = MeetingCancelAPI;
                else if(field.status == "Rejected")
                    remoreAPI = MeetingRejectAPI;
                axios.post(remoreAPI, requestData, { headers: headers }).then((response) => {
                    context.dispatch('fetchMeetings');
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(err=>{
                    resolve({ status: 500, message: 'Data not Updated.' });
                    console.log(err)
                })
            })
        });
    },
    clearAttendeeSlots_bk({ commit }){
        return new Promise((resolve, reject) => {
            let count = 0;            
           attendeeRef.get().then(querySnapshot => {
            let totallength = querySnapshot.docs.length;
                querySnapshot.docs.forEach(doc => {
                    count = count + 1;   
                    attendeeRef.doc(doc.id).collection('AvailableMeetingSlots').get().then(snapshot => {
                        if(snapshot.docs.length)
                        {
                            snapshot.docs.forEach(docSlot => {
                                attendeeRef.doc(doc.id).collection('AvailableMeetingSlots').doc(`${docSlot.id}`).delete();
                           
                            })
                        }
                        if (totallength == count)
                            resolve({ status: 200, message: 'Total ' + count + ' Rcords Deleted' })
                    })
                })
            })
        })
    },
    clearAttendeeSlots({ commit }){
        return new Promise((resolve, reject) => {
            let count = 0;
            let nocount = 0;
            const headers = {
                    "Content-Type": "application/json",
                    "apikey": "ws2000rb28082019"
                }
            
           attendeeRef.get().then(querySnapshot => {
            let totallength = querySnapshot.docs.length;
                querySnapshot.docs.forEach(doc => {                    
	                    let dataRaw = {
			            	"colname":"/"+ cn + "/AttendeeList/Attendees/"+ `${doc.id}` +"/AvailableMeetingSlots"		            	
			            }  
	                    axios.post(DeleteCollectionApi, dataRaw, { headers: headers }).then((response) => {
	                    	//console.log(response) 	                    	                   	
	                    	count = count + 1; 
	                    	if (totallength == count + nocount)
		                	{
		                		//console.log("count " + count + " no count " + nocount)
		                        resolve({ status: 200, message: 'Total ' + count + ' Rcords Deleted out of ' + totallength })               
		                	}
	                    }) 
                })

            })
        })
    },
    removeRecordOLD({ commit }, userId) {
        return new Promise((resolve, reject) => {
            meetingRef.doc(`${userId}`).delete().then(function() {
                    commit('REMOVE_RECORD', userId)
                    resolve({ status: 200, message: 'Data Deleted.' });
                })
                .catch((error) => { reject(error) })
        })
    },
    convertO2OZoomMeeting(context, meetingIds) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                    "data": {
                        "Meetings": meetingIds
                    }
                }
                
                axios.post(O2OZoomAdapter, requestData, { headers: headers }).then((response) => {
                    if(response.data.status == 0){
                        let rejected = 0;
                        let success = 0;
                        response.data.result.forEach(item=>{
                            rejected += item.status == 'rejected' ? 1 : 0;
                            success += item.status == 'fulfilled' ? 1 : 0;
                        })
                        resolve({ status: 200, message: `Operation done, ${rejected} Rejected & ${success} Success of total ${meetingIds.length} Meeting` });
                    }
                    else
                        resolve({ status: 500, message: 'Operation not done!' });
                }).catch(err=>{
                    reject(err)
                })
            })
        });
    },
    removeRecord(context, meetingIds) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                    "data": {
                        "Meetings": meetingIds
                    }
                }
                
                axios.post(MeetingDeleteAPI, requestData, { headers: headers }).then((response) => {
                    context.dispatch('fetchMeetings');
                    resolve({ status: 200, message: 'Data deleted.' });
                }).catch(err=>{
                    resolve({ status: 500, message: 'Data not deleted.' });
                    console.log(err)
                })
            })
        });
    },
    
    removeRecord2(context, meetingIds) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }

                var requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                    "data": {
                        "Meetings": meetingIds
                    }
                }
                
                axios.post(MeetingDeleteAPI2, requestData, { headers: headers }).then((response) => {
                    context.dispatch('fetchMeetings');
                    resolve({ status: 200, message: 'Data deleted.' });
                }).catch(err=>{
                    resolve({ status: 500, message: 'Data not deleted.' });
                    console.log(err)
                })
            })
        });
    },
    removeMultiRecords(context, field) {
        return new Promise((resolve, reject) => {
            //let MeetingIds = [];
            let MeetingIds = field.data.map(row=>{
                return row.MeetingId;                
            })
            context.dispatch('removeRecord', MeetingIds).then(res => {                    
                resolve(res)
            })
        })
    },
    removeMultiRecords2(context, field) {
        return new Promise((resolve, reject) => {
            //let MeetingIds = [];
            let MeetingIds = field.data.map(row=>{
                return row.MeetingId;                
            })
            context.dispatch('removeRecord2', MeetingIds).then(res => {                    
                resolve(res)
            })
        })
    },

    fetchMeetingsbyAttendeeId(context, AttendeeId) {
        let promise = new Promise(async(resolve, reject) => {
            let results = [];
            let querySnapshot = [];
            let querySnapshot1 = await meetingRef.where("Invitee.AttendeeId", "==", `${AttendeeId}`).where("Status", 'in', ["Accepted","Attended"]).get();
            let querySnapshot2 = await meetingRef.where("Requestor.AttendeeId", "==", `${AttendeeId}`).where("Status", 'in', ["Pending","Accepted","Attended"]).get();
            querySnapshot1 = querySnapshot1.docs ? querySnapshot1.docs : [];              
            querySnapshot2 = querySnapshot2.docs ? querySnapshot2.docs : []; 
            querySnapshot = querySnapshot1.concat(querySnapshot2).filter((v, i, a) => a.indexOf(v) === i);            
            //console.log(querySnapshot.length);

            let attendeeData = await attendeeRef.doc(`${AttendeeId}`).get();

            for(let doc of querySnapshot){
                //if((doc.data().Invitee && doc.data().Invitee.AttendeeId == AttendeeId) || (doc.data().Requestor && doc.data().Requestor.AttendeeId == AttendeeId)){
                    results.push({
                        MeetingId: doc.data().MeetingId,                        
                        Slots: doc.data().Slots,
                        AttendeeSlots: attendeeData.exists && attendeeData.data().Slots ? attendeeData.data().Slots : []
                    });
                //}
            }
            resolve(results);
        })
        return promise;
    },
}